import { Link } from "react-router-dom";
import Skyline from "./Skyline";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center mb-6">
              <Skyline animate={false} stroke="#ffffff" className="h-14 w-14" />
            </div>
            <p className="font-display text-3xl md:text-4xl tracking-tight font-medium leading-[1.05] max-w-md">
              Close more,<br />chase less.
            </p>
            <Link
              to="/book-demo"
              className="mt-8 inline-flex items-center rounded-full bg-white text-black text-sm px-6 py-3 transition-transform duration-300 hover:-translate-y-0.5"
              data-testid="footer-book-demo"
            >
              Book a discovery call
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <ul className="space-y-4 text-neutral-300">
              <li><Link to="/solutions" className="hover:text-white transition-colors">Solutions</Link></li>
              <li><Link to="/how-it-works" className="hover:text-white transition-colors">How it works</Link></li>
              <li><Link to="/portfolio" className="hover:text-white transition-colors">Portfolio</Link></li>
              <li><Link to="/#models" className="hover:text-white transition-colors">Models</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Journal</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/book-demo" className="hover:text-white transition-colors">Book a discovery call</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <ul className="space-y-4 text-neutral-300">
              <li><a href="mailto:hello@quexify.com" className="hover:text-white transition-colors">hello@quexify.com</a></li>
              <li className="text-neutral-500">United States &middot; Global</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-white/10 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <p className="text-neutral-500 text-sm">© {new Date().getFullYear()} Quexify. All rights reserved.</p>
          <div className="w-24 opacity-60">
            <Skyline stroke="#ffffff" animate={false} className="w-full h-20" />
          </div>
        </div>
      </div>
    </footer>
  );
}
